/**
 * @module common
 * @name MdFeelMyAccountService
 * @type service
 * @description Servicio para el manejo de la lógica de beneficios de Massimo Dutti Feel
 */
(function () {
    'use strict';

    angular.module('itxApp.legacy').factory('MdFeelMyAccountService', MdFeelMyAccountService);

    MdFeelMyAccountService.$inject = ['$q', 'CmsConfigSvc'];

    function MdFeelMyAccountService($q, CmsConfigSvc) {

        var service = {
            check200PointsEnabled: _check200PointsEnabled,
        };

        return service;

        /**
         * Función para comprobar si el sistema del beneficio de 200 puntos está activo
         */
        function _check200PointsEnabled() {
            var deferred = $q.defer();

            CmsConfigSvc.getProperty('feel_200_points_enabled').then(function (pointsBenefitEnabled) {
                // Si el sistema está activo
                if (pointsBenefitEnabled.is_enabled) {
                    // Si disponemos de fechas definidas, comprobamos si estamos en rango
                    if (pointsBenefitEnabled.start_date && pointsBenefitEnabled.end_date) {
                        if (
                            moment().isBetween(
                                moment(_parseFeel200PointsDates(pointsBenefitEnabled.start_date)),
                                moment(_parseFeel200PointsDates(pointsBenefitEnabled.end_date))
                            )
                        ) {
                            deferred.resolve(true);
                        } else {
                            deferred.resolve(false);
                        }
                    } else {
                        // En caso contrario, lo consideramos activo
                        deferred.resolve(true);
                    }
                } else {
                    deferred.resolve(false);
                }
            });

            return deferred.promise;
        }

        /**
         * Función para transformar i parsear fechas
         */
        function _parseFeel200PointsDates(inputDateTime) {
            const splittedDateTime = inputDateTime.split(' ');
            const reorderedDate =
                splittedDateTime[0].split('-')[2] + '-' + splittedDateTime[0].split('-')[1] + '-' + splittedDateTime[0].split('-')[0];

            return reorderedDate + ' ' + splittedDateTime[1];
        }
    }
})();
